import React from 'react';
import GameOddsCard from './GameOddsCard';
import { formatDateHeader, BET_LIMITS } from '../../constants/sports';

function SportGamesView({ games, sportKey, betSlipLegs, onToggleLeg, onViewProps }) {
  const now = Date.now();
  const closeMs = BET_LIMITS.BETTING_CLOSE_MINUTES * 60 * 1000;

  // Client-side classification using real-time clock
  const liveGames = games.filter(g => g.status === 'in_progress');
  const completedGames = games.filter(g => g.status === 'completed');
  const scheduledGames = games.filter(g => g.status === 'scheduled');
  const bettableGames = scheduledGames.filter(g => g.markets && (g.commenceTime - now) >= closeMs);
  const closedGames = scheduledGames.filter(g => !g.markets || (g.commenceTime - now) < closeMs);

  // Group bettable games by date
  const grouped = {};
  for (const game of bettableGames) {
    const dateKey = formatDateHeader(game.commenceTime);
    if (!grouped[dateKey]) grouped[dateKey] = [];
    grouped[dateKey].push(game);
  }

  // Sort groups by earliest game time, then sort within each group
  const sortedGroups = Object.entries(grouped).sort((a, b) => {
    return a[1][0].commenceTime - b[1][0].commenceTime;
  });
  for (const [, dateGames] of sortedGroups) {
    dateGames.sort((a, b) => a.commenceTime - b.commenceTime);
  }

  return (
    <div className="sports-games-view">
      {/* Live games banner */}
      {liveGames.length > 0 && (
        <div className="sports-section">
          <h3 className="sports-section-header">
            <span className="sports-live-dot" /> Live
          </h3>
          {liveGames.map(game => (
            <GameOddsCard key={game.id} game={game} sportKey={sportKey} betSlipLegs={betSlipLegs} onToggleLeg={onToggleLeg} disabled />
          ))}
        </div>
      )}

      {/* Bettable games by date */}
      {sortedGroups.map(([dateKey, dateGames]) => (
        <div key={dateKey} className="sports-section">
          <h3 className="sports-section-header">{dateKey}</h3>
          {dateGames.map(game => (
            <GameOddsCard key={game.id} game={game} sportKey={sportKey} betSlipLegs={betSlipLegs} onToggleLeg={onToggleLeg} onViewProps={onViewProps} />
          ))}
        </div>
      ))}

      {/* Closing soon / no odds */}
      {closedGames.length > 0 && (
        <div className="sports-section">
          <h3 className="sports-section-header sports-closed-header">Betting Closed</h3>
          {closedGames.map(game => (
            <GameOddsCard key={game.id} game={game} sportKey={sportKey} betSlipLegs={betSlipLegs} onToggleLeg={onToggleLeg} disabled />
          ))}
        </div>
      )}

      {/* Completed */}
      {completedGames.length > 0 && (
        <div className="sports-section">
          <h3 className="sports-section-header sports-completed-header">Final</h3>
          {completedGames.slice(0, 5).map(game => (
            <GameOddsCard key={game.id} game={game} sportKey={sportKey} betSlipLegs={betSlipLegs} onToggleLeg={onToggleLeg} disabled />
          ))}
        </div>
      )}

      {bettableGames.length === 0 && liveGames.length === 0 && completedGames.length === 0 && closedGames.length === 0 && (
        <div className="sports-empty">No games available right now.</div>
      )}
    </div>
  );
}

export default SportGamesView;
